var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5999 40.8C19.5999 43.451 17.4509 45.6 14.7999 45.6C12.1489 45.6 9.9999 43.451 9.9999 40.8C9.9999 38.1491 12.1489 36 14.7999 36C17.4509 36 19.5999 38.1491 19.5999 40.8Z",
    fill: "#9EA3AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9999 40.8C41.9999 43.451 39.8509 45.6 37.1999 45.6C34.5489 45.6 32.3999 43.451 32.3999 40.8C32.3999 38.1491 34.5489 36 37.1999 36C39.8509 36 41.9999 38.1491 41.9999 40.8Z",
    fill: "#9EA3AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5999 0.800049C1.83259 0.800049 0.399902 2.23274 0.399902 4.00005V36C0.399902 37.7674 1.83259 39.2001 3.5999 39.2001H6.95993C7.70116 35.5485 10.9296 32.8 14.7999 32.8C18.6702 32.8 21.8986 35.5485 22.6399 39.2001H25.9999C27.7672 39.2001 29.1999 37.7674 29.1999 36V4.00005C29.1999 2.23274 27.7672 0.800049 25.9999 0.800049H3.5999Z",
    fill: "#9EA3AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7999 10.4C37.0326 10.4 35.5999 11.8327 35.5999 13.6V32.9601C36.1169 32.8551 36.652 32.8 37.1999 32.8C41.0702 32.8 44.2986 35.5485 45.0399 39.2001H48.3999C50.1672 39.2001 51.5999 37.7674 51.5999 36V20C51.5999 19.1514 51.2628 18.3374 50.6626 17.7373L44.2626 11.3373C43.6625 10.7372 42.8486 10.4 41.9999 10.4H38.7999Z",
    fill: "#9EA3AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.103136c693f504517d5ba6ee12846e96.svg";
export { ForwardRef as ReactComponent };